import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const servicioImporterSelectors = importerSelectors(
  'servicio.importer',
);

export default servicioImporterSelectors;
